<template>
	<ul :class="`${name}_wrap`">
		<li
			v-for="(item, idx) in items"
			:key="`${name}_${idx}`"
			:class="`${name}_item`"
		>
			<div
				@click="clickAccordion(idx, item.date)"
				:id="`title_${idx}`"
				class="title"
				:class="{ active: activeAccordionList.includes(idx) }"
			>
				<slot name="title" :item="item"></slot>
			</div>
			<div :id="`content_${idx}`" class="content">
				<slot name="content" :item="item" :idx="idx"></slot>
			</div>
		</li>
	</ul>
</template>

<script>
import { onActivated, ref, getCurrentInstance } from 'vue';
export default {
	name: 'BaseAccordion',
	props: {
		items: {
			type: Array,
			require: true,
		},
		name: {
			type: String,
			require: true,
		},
		type: {
			type: String,
			default: 'multi',
		},
		isSelectLine: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		onActivated(() => {
			if (!props.isSelectLine) {
				closeAllAccordion();
			}
		});
		const { proxy } = getCurrentInstance();
		const prevContentIdx = ref(null);
		const activeAccordionList = ref([]);
		const clickAccordion = (idx, date) => {
			const prevContent = document.getElementById(
				`content_${prevContentIdx.value}`,
			);
			const content = document.getElementById(`content_${idx}`);
			if (props.type === 'multi') {
				// 다중 open
				if (activeAccordionList.value.includes(idx)) {
					const index = activeAccordionList.value.indexOf(idx);
					activeAccordionList.value.splice(index, 1);
					content.style.maxHeight = null;
					emit('closeAccordion');
					return;
				}
				activeAccordionList.value.push(idx);
				content.style.maxHeight = content.scrollHeight + 'px';
				emit('openAccordion', { idx, date });
				return;
			}
			// 하나만 open
			if (prevContentIdx.value === null) {
				prevContentIdx.value = idx;
				activeAccordionList.value.push(idx);
				content.style.maxHeight = `calc(${content.scrollHeight}px + 1000px)`;
				emit('openAccordion', { idx, date });
				return;
			}
			if (prevContentIdx.value === idx) {
				if (activeAccordionList.value.includes(idx)) {
					const index = activeAccordionList.value.indexOf(idx);
					activeAccordionList.value.splice(index, 1);
					content.style.maxHeight = null;
					return;
				}
				activeAccordionList.value.push(idx);
				content.style.maxHeight = `calc(${content.scrollHeight}px + 1000px)`;
				return;
			}
			if (props.isSelectLine) {
				const popupInfo = {
					title: '날짜를 변경하시겠습니까?',
					content: '날짜 변경시 입력된 내용이 모두 삭제됩니다.',
					leftBtnName: '아니오',
					rightBtnName: '네, 변경할게요',
					onLeftBtn: () => {
						proxy.$root.$closePopup();
					},
					onRightBtn: () => {
						proxy.$root.$closePopup();
						prevContent.style.maxHeight = null;
						emit('closeAccordion');
						activeAccordionList.value = [];
						activeAccordionList.value.push(idx);
						content.style.maxHeight = `calc(${content.scrollHeight}px + 1000px)`;
						emit('openAccordion', { idx, date });
						prevContentIdx.value = idx;
					},
				};
				proxy.$root.$openPopup(popupInfo);
				return;
			}
			prevContent.style.maxHeight = null;
			emit('closeAccordion');
			activeAccordionList.value = [];
			activeAccordionList.value.push(idx);
			content.style.maxHeight = `calc(${content.scrollHeight}px + 1000px)`;
			emit('openAccordion', { idx, date });
			prevContentIdx.value = idx;
		};

		const closeAllAccordion = () => {
			activeAccordionList.value = [];
			prevContentIdx.value = null;
			for (let i = 0; i < props.items.length; i++) {
				const content = document.getElementById(`content_${i}`);
				const title = document.getElementById(`title_${i}`);
				content.classList.remove('active');
				title.classList.remove('active');
				content.style.maxHeight = null;
			}
		};
		// 초기 설정
		if (props.items.length === 1) {
			const content = document.getElementById('content_0');
			const title = document.getElementById('title_0');
			content.classList.add('active');
			title.classList.add('active');
			emit('openAccordion', { idx: 0, date: props.items[0].date });
		}
		return {
			activeAccordionList,
			clickAccordion,
		};
	},
};
</script>
